import { PERMISSIONS } from '@repo/contracts';

import { selectCan } from '@/store/auth.slice';
import { useAppSelector } from '@/store/store';

import { useSyncConflicts } from './use-sync-conflicts';

/** How many conflicts are open, for the navigation badge; zero until known or when the viewer may not read them. */
export const useOpenConflictCount = (): number => {
  const canRead = useAppSelector(selectCan(PERMISSIONS.directoryRead));
  const { data } = useSyncConflicts(canRead);

  return data?.items.length ?? 0;
};
